import script from "./PAASList.vue?vue&type=script&setup=true&lang=js"
export * from "./PAASList.vue?vue&type=script&setup=true&lang=js"

import "./PAASList.vue?vue&type=style&index=0&id=68fb725c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68fb725c"]])

export default __exports__